export default __webpack_public_path__ + "static/media/Group 3201@2x.963c261d.png";